import POS from './POS';
export default POS;